import React from 'react';
import Icon from '../shared/Icon';
import './TabStateIcon.css';
import { TAB_STATE, TAB_STATE_ICON } from './tabsUtils';

// The one icon a tab shows for its state — private, shared by you, shared with you.
// Same size and muted colour for all three; the label carries the meaning for screen
// readers and the tooltip for everyone else.
function TabStateIcon({ state }) {
  const meta = TAB_STATE_ICON[state] || TAB_STATE_ICON[TAB_STATE.PRIVATE];
  return (
    <Icon name={meta.icon} className="tab-state-icon" title={meta.label} role="img" />
  );
}

export default TabStateIcon;
